/**
 * Define a list of available application languages
 */
export const LANGUAGES = {
  ENGLISH: { name: "APP.LBL_ENGLISH", value: "en-US" },
  SPANISH: { name: "APP.LBL_SPANISH", value: "es-US" }
};

/**
 * list of available date formats
 * @see https://angular.io/api/common/DatePipe
 */
export const DATES = {
  SHORT_DATE: { name: "APP.LBL_SHORT_DATE", value: "shortDate" },
  MEDIUM_DATE: { name: "APP.LBL_MEDIUM_DATE", value: "mediumDate" },
  LONG_DATE: { name: "APP.LBL_LONG_DATE", value: "longDate" },
  FULL_DATE: { name: "APP.LBL_FULL_DATE", value: "fullDate" }
};

export const TIMESTAMP = {
  SHORT: { name: "APP.LBL_SHORT", value: "short" },
  MEDIUM: { name: "APP.LBL_MEDIUM", value: "medium" },
  LONG: { name: "APP.LBL_LONG", value: "long" },
  FULL: { name: "APP.LBL_FULL", value: "full" }
};
